import React, { type JSX } from 'react';
import styles from './HorizontalImageTile.module.scss';
import OptimizedImage from '../OptimizedImage/OptimizedImage';
import Link from 'next/link';

export type HorizontalImageTileViewModel = {
  imageUrl: string;
  titlePartOne: string;
  titlePartTwo: string;
  content: string;
  href?: string;
  containerClassName?: string;
  categoryTitle: string;
};

export default function HorizontalImageTile({
  imageUrl,
  titlePartOne,
  titlePartTwo,
  content,
  href,
  containerClassName,
}: HorizontalImageTileViewModel): JSX.Element {
  let tile = (
    <div className={`${styles.container} ${containerClassName ?? ''}`}>
      <div className={styles.tileImage}>
        <OptimizedImage
          src={imageUrl}
          alt={`${titlePartOne} ${titlePartTwo}`}
          isZoomable={false}
          includeMargin={false}
        />
      </div>
      <span
        className={styles.resourceTitle}
      >{`${titlePartOne} ${titlePartTwo}`}</span>
      <span className={styles.resourceDescription}>{content}</span>
    </div>
  );

  if (href) {
    tile = <Link href={href}>{tile}</Link>;
  }

  return tile;
}
